module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "super-admin"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Super admin</b>"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Super Admin indstillinger\n            ")])]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Funktioner:")]), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Opret nye virksomheder (onboarding)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                    Block\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                    Block\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ff05cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/superadmin/index.vue
// module id = 897
// module chunks = 0